import $ from 'jquery';
import '@component/polyfills';
import 'alpinejs/dist/alpine-ie11';
import balanceText from 'balance-text';
import { FireLazyLoader, FireDetect, FireComponentRecord } from '@component';
import { moveBootstrapModalsToBody, iOSFixDoubleTap, ignoreContext } from '@utility';

const detect = new FireDetect();
const componentRecord = new FireComponentRecord();
const lazyLoader = new FireLazyLoader();

/**
 * @type function
 * @name onPageReady
 * @description
 *
 * Initialize scripts when page is ready
 *
 **/
const onPageReady = () => {
  detect.setHtmlClasses();
  detect.detectTrueViewHeight();
  lazyLoader.init();
  lazyLoader.observer.observe();
  componentRecord.registerAllComponents();
  moveBootstrapModalsToBody();

  if (detect.touch && (detect.platform === 'iPhone' || detect.platform === 'iPad')) {
    iOSFixDoubleTap();
  }

  balanceText();

  $('.link-arrow').each(function () {
    var $this = $(this),
      text = $this.text().trim(),
      words = text.split(/\s+/);
    var lastWord = words.pop();
    words.push('<span class="last">' + lastWord + '</span>');
    $this.html(words.join(' '));
  });

  // display page
  $('body').removeClass('opacity-0');
};

// fire all scripts
$(document).ready(onPageReady);
